import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container px-5 py-4" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex position-fixed w-100 h-100 align-items-center justify-content-center",
  style: {"z-index":"100000","background-color":"rgba(255, 255, 255, 0.75)","left":"0px","top":"0px"}
}
const _hoisted_3 = { class: "d-block text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-success",
  role: "status"
}, null, -1)
const _hoisted_5 = { class: "row gy-3 mb-3" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "row mt-5" }
const _hoisted_9 = { class: "col-6 col-md-6 d-flex justify-content-start" }
const _hoisted_10 = { class: "col-6 col-md-6 d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInfoTitles = _resolveComponent("AppInfoTitles")!
  const _component_AppDisclaimer = _resolveComponent("AppDisclaimer")!
  const _component_PersonalDate = _resolveComponent("PersonalDate")!
  const _component_CompanionDetails = _resolveComponent("CompanionDetails")!
  const _component_Documentation = _resolveComponent("Documentation")!
  const _component_TermsAndConditions = _resolveComponent("TermsAndConditions")!
  const _component_AppButtonReturn = _resolveComponent("AppButtonReturn")!
  const _component_AppButtonContinue = _resolveComponent("AppButtonContinue")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading.status)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("h6", null, _toDisplayString(_ctx.loading.text), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Form, { onSubmit: _ctx.onSubmit }, {
      default: _withCtx(() => [
        _createVNode(_component_AppInfoTitles),
        _createVNode(_component_AppDisclaimer),
        _createVNode(_component_PersonalDate, {
          modelValue: _ctx.form.personal,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.personal) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.t('formDatos.titles.subtitle3')), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_CompanionDetails, {
              modelValue: _ctx.form.acompanianteUno,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.acompanianteUno) = $event)),
              "label-name": "formularios.nombreAcom1.label"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_CompanionDetails, {
              modelValue: _ctx.form.acompanianteDos,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.acompanianteDos) = $event)),
              "label-name": "formularios.nombreAcom2.label"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_CompanionDetails, {
              modelValue: _ctx.form.acompanianteTres,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.acompanianteTres) = $event)),
              "label-name": "formularios.nombreAcom3.label"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode(_component_Documentation, {
          modelValue: _ctx.form.documentacion,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.documentacion) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_TermsAndConditions, {
          modelValue: _ctx.form.terminos,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.terminos) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_AppButtonReturn)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_AppButtonContinue, {
              disabled: _ctx.loading.status
            }, null, 8, ["disabled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}